// This is the regular expression that the back-end uses to validate the format of an email. This
// was copied to the front-end to prevent unnecessary network requests where the response is known.
const emailRegExpFromMainApp = /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,12}$/i;

export default emailRegExpFromMainApp;
